import actionTypes from './actionTypes';

export function setCurrentStripe(payload) {
    return {
        type: actionTypes.SET_CURRENT_STRIPE,
        payload,
    };
}
